import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { Button,Divider,Skeleton,Stack } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { ReactNode,useEffect,useState } from 'react';
import QueryFn from '../../../helpers/QueryFn';
import Reports from '../../../service/Reports';
import { avaliacaoType,ChamadosArrayType,ChamadoSubitem,ChecklistReportType,HistoricoChamado,Subitem,Ticket } from "../../../types/reports/types";
import ChamadosDuplicados from '../../Notifications/ChamadosDuplicados';

const reportsService = new Reports();
const queryFn = new QueryFn();

export default function ChamadosDetalhe({ chamadosArray, form, radioOption, showDuplicatas }: { chamadosArray: ChamadosArrayType, form: ChecklistReportType, radioOption: string, showDuplicatas: boolean }) {
  const subitens = chamadosArray?.ticketDetails?.subitens as Record<string, ChamadoSubitem> | undefined;

  const ImageToShow = ({
    path,
    wid,
    hei,
    rotate,
    translate,
    skeletonWid,
    skeletonHei }: {
      path: string,
      wid: number,
      hei: number,
      rotate: number,
      translate: number,
      skeletonWid: number,
      skeletonHei: number
    }) => {
    const [image, setImage] = useState<string>('');
    const { mutate, data, isPending } = queryFn.useMutate('GET_IMAGES',
      async (path?: string) => {
        const response = await reportsService.getImages([path!]);
        return response;
      }
    );

    function resizeBase64Image(base64Image: string, wid: number, hei: number): Promise<string> {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = base64Image;
        img.onload = () => {
          let newWidth = wid;
          let newHeight = hei;

          const canvas = document.createElement('canvas');
          canvas.width = newHeight;
          canvas.height = newWidth;

          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.translate(0, translate);
            ctx.rotate(rotate);

            ctx.drawImage(img, 0, 0, newWidth, newHeight);

            const resizedBase64 = canvas.toDataURL('image/jpeg');
            resolve(resizedBase64);
            setImage(resizedBase64);
          } else {
            reject(new Error("Erro ao obter contexto 2D"));
          }
        };
        img.onerror = (err) => {
          console.error("Erro ao carregar a imagem: ", err);
          resolve('/sem_anexo.png');
        };
      });
    }

    useEffect(() => {
      mutate(path);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      resizeBase64Image(data, wid, hei);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPending]);

    return (
      isPending
        ? <Skeleton variant='rounded' height={skeletonHei} width={skeletonWid} />
        : data &&
        <img style={{ objectFit: 'cover' }} src={image} alt="Imagem" />
    );
  };

  const formatStatus = (value: string) => {
    switch (value) {
      case 'pendente':
        return 'Pendente';
      case 'concluido':
        return 'Concluído';
      case 'emAndamento:':
      case 'emandamento':
        return 'Em Andamento';
      case 'recusado':
        return 'Recusado';
      case 'cancelado':
        return 'Cancelado';
    }
  };

  const ListaAcoes = ({ historico }: { historico: HistoricoChamado | undefined }) => {
    return (
      <>
        {historico
          && radioOption === 'all'
          && <> <Typography variant='h6'>Lista de Ações</Typography>
            <Card variant='outlined' sx={{ width: '100%' }}>
              {Object?.values(historico)?.map((chamado) => {
                return (
                  <div style={{ width: '100%' }} key={chamado?.id}>
                    <Stack
                      width='100%'
                      style={{ padding: '20px' }}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={0.5}
                    >
                      <Stack
                        width='100%'
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={0.5}
                      >
                        <Stack
                          sx={{ fontSize: '14px' }}
                          direction="column"
                          justifyContent="flex-start"
                          alignItems="flex-start"
                          spacing={1}
                        >

                          <Typography variant='h5'>
                            {chamado?.nomeUsuarioAcompanhamento}
                          </Typography>
                          <span style={{ fontWeight: 600 }}>
                            Data de atendimento:&nbsp;
                            <span style={{ fontWeight: 400 }}>
                              {typeof chamado.data === 'number'
                                ? new Date(chamado.data).toLocaleString('pt-BR')
                                : chamado?.data || ''}
                            </span>
                          </span>
                          <span style={{ fontWeight: 600 }}>
                            Comentário:&nbsp;
                            <span style={{ fontWeight: 400 }}>
                              {chamado.comentario || '-'}
                            </span>
                          </span>
                          <span style={{ fontWeight: 600 }}>
                            Status:&nbsp;
                            <span style={{ fontWeight: 400 }}>
                              {formatStatus(chamado.status) || '-'}
                            </span>
                          </span>
                        </Stack>
                      </Stack>
                      {chamado?.foto?.length
                        && <ImageToShow
                          path={chamado?.foto as string}
                          wid={120}
                          hei={120}
                          rotate={0}
                          translate={0}
                          skeletonWid={120}
                          skeletonHei={120} />}
                    </Stack>
                    <span style={{ fontSize: '13px', padding: '10px' }}>
                      Atualizado em:&nbsp;{typeof chamado?.dataMensagem === 'number'
                        ? new Date(chamado?.dataMensagem)?.toLocaleString('pt-BR')
                        : chamado?.dataMensagem || '-'}
                    </span>
                    <Divider variant="middle" />
                  </div>
                );
              })}
            </Card>
          </>
        }
      </>
    );
  };

  const DetailComp = ({ chamados }: { chamados: Ticket[] }) => {
    return (
      chamados?.map((ticket: Ticket) => {
        return (
          <Stack
            key={ticket?.id}
            width='100%'
            sx={{ fontSize: '13px', color: 'gray' }}
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={0.5}
          >
            <Stack
              width='100%'
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              spacing={1}
            >
              <Stack
                direction='column'
                alignItems='flex-start'
                justifyContent='flex-start'
                width='100%'
                spacing={.5}
              >
                <Typography variant='h6'>
                  Informações do chamado:
                </Typography>
                <span style={{ fontWeight: 600 }}>
                  Título:&nbsp;
                  <span style={{ fontWeight: 400 }}>
                    {ticket?.nomeChamado}
                  </span>
                </span>
                <span style={{ fontWeight: 600 }}>
                  Status:&nbsp;
                  <span style={{ fontWeight: 400 }}>
                    {formatStatus(ticket?.status)}
                  </span>
                </span>
                <span style={{ fontWeight: 600 }}>
                  Data limite:&nbsp;
                  <span style={{ fontWeight: 400 }}>
                    {typeof ticket.dataPrevisao === 'number'
                      ? new Date(ticket?.dataPrevisao).toLocaleString('pt-BR')
                      : ticket.dataPrevisao}
                  </span>
                </span>
                <span style={{ fontWeight: 600 }}>
                  Data de abertura:&nbsp;
                  <span style={{ fontWeight: 400 }}>
                    {typeof ticket.inicio === 'number'
                      ? new Date(ticket?.inicio).toLocaleString('pt-BR')
                      : ticket.inicio}
                  </span>
                </span>
                <span style={{ fontWeight: 600 }}>
                  Data da última mudança de status:&nbsp;
                  <span style={{ fontWeight: 400 }}>
                    {new Date(ticket?.lastUpdateDate)?.toLocaleString('pt-BR')}
                  </span>
                </span>
                <span style={{ fontWeight: 600 }}>
                  Usuário responsável pela última ação:&nbsp;
                  <span style={{ fontWeight: 400 }}>
                    {ticket?.nomeUsuario}
                  </span>
                </span>
                <span style={{ fontWeight: 600 }}>
                  Prioridade:&nbsp;
                  <span style={{ fontWeight: 400 }}>
                    {ticket?.prioridade?.replace(/^(.)/, (c: string) => c.toUpperCase())}
                  </span>
                </span>
              </Stack>
              {ticket?.originalId
                && <Button
                  onClick={() => window.open(process.env.REACT_APP_AXYMA_FRONT_URL + 'detalheChamado/' + ticket?.originalId)}
                  variant='contained'
                  color='secondary'
                  endIcon={<SubdirectoryArrowRightIcon />}>
                  Ver chamado original
                </Button>}
            </Stack>
            {ticket?.duplicatasLista && showDuplicatas && <ChamadosDuplicados duplicatas={ticket?.duplicatasLista} />}
            <ListaAcoes historico={ticket?.historicoChamado} />
          </Stack>
        );
      })
    );
  };

  const renderizaResposta = (subitem: Subitem, id: string) => {
    const itemId = Number(id.split('|')[0]);
    const sub = form?.itens?.[itemId]?.subitens[subitem.subitemId];
    switch (subitem.tipo) {
      case 'assinatura':
        return (
          <ImageToShow
            path={subitem?.resposta as string}
            wid={100}
            hei={200}
            rotate={-Math.PI / 2}
            translate={100}
            skeletonWid={200}
            skeletonHei={100}
          />
        );
      case 'avaliacao': {
        const avaliacao = sub?.avaliacao as avaliacaoType[] | undefined | null;
        return (
          <Typography fontSize={13} component='tr'>&nbsp;{avaliacao ? avaliacao[subitem?.resposta as number]?.nome : '-'}</Typography>
        );
      }
      case 'list':
        return (
          (subitem.resposta as { texto: string }[]).map((ele) => {
            return (<Typography fontSize={13} component='tr'>&nbsp;{ele.texto}</Typography>);
          })
        );
      case 'multiple':
      case 'unique':
        return (
          (sub?.selecao as unknown as string[])?.map((ele: string, index: number) => {
            if (Array.isArray(sub?.selecionados) && (sub.selecionados)[index]) {
              return (<Typography fontSize={13} component='tr'>&nbsp;{ele}</Typography>);
            }
            return null;
          })
        );
      case 'data':
        return (<Typography fontSize={13} component='tr'> &nbsp;{typeof subitem?.resposta === 'number'
          ? new Date(subitem?.resposta).toLocaleString('pt-BR')
          : (subitem?.resposta as string | null | undefined)} </Typography>);
      default: return <Typography fontSize={13} component='tr'>&nbsp;{subitem?.resposta as ReactNode}</Typography>;
    }
  };

  return (
    <Card sx={{ width: '100%' }}>
      <CardContent>
        <Typography variant='subtitle1' sx={{ color: 'gray' }}>
          CHAMADOS
        </Typography>
        <Typography>
          {form.nome}
        </Typography>
        <DetailComp chamados={chamadosArray?.ticketDetails?.formulario as Ticket[]} />
        <Typography>
          {Object.keys(subitens ?? {})?.length > 0 &&
            <>
              <Typography variant='subtitle1' sx={{ marginTop: '15px', color: 'gray' }}>
                SUBITENS
              </Typography>
              {Object?.keys(subitens ?? {})
                ?.sort((a, b) => a?.toLowerCase() > b?.toLowerCase() ? 1 : -1)
                ?.map((id: string) => {
                  const subItem = subitens?.[id] as ChamadoSubitem;
                  return (<>
                    <Stack
                      width='100%'
                      direction="column"
                      justifyContent="flex-start"
                      alignItems="flex-start"
                      spacing={0.5}
                    >
                      <span>
                        {`${id.replace('|', ' . ')} - ${subItem?.nomeItem}: ${subItem?.nome}`}
                      </span>
                      <Stack
                        width='100%'
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={0.5}
                      >
                        Pergunta:<Typography fontSize={13} component='span' sx={{ wordBreak: 'break-word' }}> {renderizaResposta(subItem as Subitem, id)}</Typography>
                      </Stack>
                      <DetailComp chamados={subItem?.chamados as Ticket[]} />
                    </Stack>
                    <Divider variant='middle' />
                  </>
                  );
                })}
            </>
          }
        </Typography>
      </CardContent>
    </Card >
  );
}